export default function (id, headerHeight, tableContainerId, numberOfColumn = 1, sort = false) {
    const tableElement = document?.getElementById(id);
    let copy;
    let div;
    const tableContainer = document?.getElementById(tableContainerId)

    const hadleScrollEvent = (event) => {
        div.scrollTo({ left: tableContainer?.scrollLeft })
    }

    // check if clone div exist 
    if (!document?.getElementById('table_copy')) {
        // clone whole table
        copy = tableElement?.cloneNode(true);

        copy.setAttribute("id", "table_copy");
        const tableContainerWidth = tableContainer?.clientWidth;
        div = document.createElement("div");
        div.setAttribute("id", "table_copy_main");
        div.style.maxWidth = `${tableContainerWidth}px`;
        div.style.position = "fixed";
        div.style.top = `${headerHeight - 1}px`;
        div.style.zIndex = 8;
        div.style.overflowX = "hidden";

        // added scroll handler for horizontal scroll
        tableContainer?.addEventListener("scroll", hadleScrollEvent);
        // add clone table in div
        div.appendChild(copy);
        // remove tbody element from clone table
        copy.removeChild(copy.childNodes[1]);
        // get columns of clone table header
        const child = copy.childNodes[0].childNodes[0].childNodes;
        // iteereate over actual to set actual width of every clone tabloe header columns
        tableElement.childNodes[1].childNodes[0].childNodes.forEach((thTag, index) => {
            if (index < numberOfColumn) {
                child[index].style.zIndex = 9999;
            }
            // get actual table columns width
            const width = getComputedStyle(thTag).getPropertyValue("width");
            // Added as min width to clone table header
            // child[index].style.minWidth = width;
            child[index].style.cssText = "min-width: " + width + "!important"
        });
        // add in same parent div where actual table exist
        tableElement.parentNode.insertBefore(div, null)
        // if table horizontally scrolled
        div.scrollTo({
            left: tableContainer?.scrollLeft
        })
    }
    else {
        copy = document?.getElementById('table_copy')
        div = document?.getElementById("table_copy_main");
    }
    let handleClickSort;
    if (sort && typeof sort === 'function') {
        // sort function for columns must have "arialabel" attribute with unique sort key
        handleClickSort = (event) => {
            //attach aria-label attribute apply sorting feature to particular column
            const columnSortingName = event.target.getAttribute("aria-label");
            if(columnSortingName) {
                ///sorting  function unique for every tabl
                sort(columnSortingName)
            }
        }

        //Added event listerner- here we can add listeners to trigger user event function
        copy.addEventListener("click", handleClickSort);
    }

    return () => {
        div.removeEventListener("scroll", hadleScrollEvent);
        if (sort && typeof sort === 'function') {
            copy.removeEventListener("click", handleClickSort);
        }
        div.remove();
        tableContainer?.removeEventListener("scroll", hadleScrollEvent);
    }


    /**
     * change display height for copy header local and sbx( navbar navbar-default white)
     */
}